import * as React from "react";

export interface Reset {
  username: string;
  type: Type;
}

export enum Type {
  "Email",
  "Phone",
}

interface ContextState {
  userToken: Reset;
}

interface ResetContextControllerProps {
  saveOutput: Function;
}

export const ResetPasswordContext = React.createContext(
  [] as (ContextState | ResetContextControllerProps | any)[]
);
const Manipulator = (prevState: any, action: any) => {
  switch (action.type) {
    case "SAVE_OUTPUT":
      return {
        ...prevState,
        userToken: action.token,
      };

    default:
      return prevState;
  }
};

const ResetPasswordContextContainer: React.FC = ({ children }) => {
  const [resetState, setResetState] = React.useReducer(Manipulator, {
    userToken: null,
  });

  const ResetContextController = React.useMemo(
    () => ({
      saveOutput: async (token: object): Promise<void> => {
        setResetState({ type: "SAVE_OUTPUT", token });
      },
    }),
    []
  );
  return (
    <React.Fragment>
      <ResetPasswordContext.Provider
        value={[ResetContextController, resetState]}
      >
        {children}
      </ResetPasswordContext.Provider>
    </React.Fragment>
  );
};

export default ResetPasswordContextContainer;
